import React, { useEffect, useState } from "react";
import { Modal } from "rsuite";
import { FiUser, FiMail, FiBriefcase, FiFolder, FiHome } from "react-icons/fi";

const LABEL_CLASS =
  "mb-1 flex items-center gap-1.5 text-sm font-semibold text-gray-700 dark:text-gray-300";

const FIELD_CLASS =
  "w-full rounded-xl border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm text-navy-700 dark:border-gray-600 dark:bg-navy-900 dark:text-white";

const ModalViewDetailTeam: React.FC<any> = ({
  openTeamDetailModal,
  setOpenTeamDetailModal,
  details,
}) => {
  const [detail, setDetail] = useState<any>({});

  useEffect(() => {
    setDetail(details);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openTeamDetailModal]);

  const handleClose = () => {
    setOpenTeamDetailModal(false);
  };

  return (
    <Modal open={openTeamDetailModal} size={"lg"} onClose={handleClose}>
      <Modal.Header className="border-b border-gray-100 pb-3 dark:border-navy-700">
        <Modal.Title>
          <span className="text-lg font-bold text-navy-700 dark:text-white">
            Detalhes do colaborador
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="grid grid-cols-1 gap-x-6 gap-y-4 py-2 sm:grid-cols-2">
          <div className="flex flex-col">
            <label htmlFor="team-detail-name" className={LABEL_CLASS}>
              <FiUser className="text-dv-blue-500" aria-hidden="true" /> Nome
            </label>
            <input
              id="team-detail-name"
              disabled
              value={detail?.nmEmployee ?? ""}
              className={FIELD_CLASS}
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="team-detail-email" className={LABEL_CLASS}>
              <FiMail className="text-dv-blue-500" aria-hidden="true" /> E-mail
            </label>
            <input
              id="team-detail-email"
              disabled
              value={detail?.email ?? ""}
              className={FIELD_CLASS}
            />
          </div>
          <div className="flex flex-col sm:col-span-2">
            <label htmlFor="team-detail-job" className={LABEL_CLASS}>
              <FiBriefcase className="text-dv-blue-500" aria-hidden="true" /> Cargo
            </label>
            <input
              id="team-detail-job"
              disabled
              value={detail?.jobDescription ?? ""}
              className={FIELD_CLASS}
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="team-detail-project" className={LABEL_CLASS}>
              <FiFolder className="text-dv-blue-500" aria-hidden="true" /> Projeto
            </label>
            <input
              id="team-detail-project"
              disabled
              value={detail?.nmProject ?? ""}
              className={FIELD_CLASS}
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="team-detail-client" className={LABEL_CLASS}>
              <FiHome className="text-dv-blue-500" aria-hidden="true" /> Cliente
            </label>
            <input
              id="team-detail-client"
              disabled
              value={detail?.nmCorporate ?? ""}
              className={FIELD_CLASS}
            />
          </div>
          <div className="flex flex-col sm:col-span-2">
            <span className={LABEL_CLASS}>Status</span>
            <span
              className={`inline-flex w-fit items-center rounded-full px-2.5 py-1 text-[11px] font-semibold ${
                detail?.flActive
                  ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300"
                  : "bg-gray-100 text-gray-700 dark:bg-navy-700 dark:text-gray-300"
              }`}
            >
              {detail?.flActive ? "Ativo" : "Inativo"}
            </span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-t border-gray-100 pt-4 dark:border-navy-700">
        <button
          type="button"
          onClick={handleClose}
          className="flex items-center justify-center gap-1.5 rounded-xl border border-gray-200 px-5 py-2.5 text-sm font-semibold text-gray-700 transition-all hover:bg-gray-50 active:scale-[.98] dark:border-white/15 dark:text-gray-200 dark:hover:bg-navy-700"
        >
          Fechar
        </button>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalViewDetailTeam;
